const rootActionPath = 'core/EmailOptInSubscribeModal';

export const EMAIL_OPT_IN_MODAL_SUBSCRIBE_VIEW = `${rootActionPath}/VIEW`;

export const EMAIL_OPT_IN_MODAL_USER_CHOICE_NO_THANKS = '0';
export const EMAIL_OPT_IN_MODAL_USER_CHOICE_CLOSE = '-1';
export const EMAIL_OPT_IN_MODAL_USER_CHOICE_SUBSCRIBE = '1';
